/*
 * Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { getAuth } from '@/auth/authRef'
import { reportClick } from '@/metrics/uiMetrics'

/** A Sign in press: GH's uiClick `signIn` with the surrounding surface's content name, then sign-in. */
export function startSignIn(contentName?: string, refMarker?: string): void {
    reportClick({
        actionType: 'signIn',
        ...(contentName === undefined ? {} : { contentName }),
        ...(refMarker === undefined ? {} : { refMarker }),
    })
    getAuth().signIn()
}
